var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4128 6L11.9145 0.498304C11.9882 0.424564 12.017 0.317085 11.99 0.216354C11.9631 0.115623 11.8844 0.0369436 11.7836 0.00995276C11.6829 -0.017038 11.5754 0.0117608 11.5017 0.085501L6 5.5872L0.498304 0.085501C0.384312 -0.0284915 0.199493 -0.0284915 0.085501 0.085501C-0.0284915 0.199493 -0.0284915 0.384312 0.085501 0.498304L5.5872 6L0.085501 11.5017C0.0117608 11.5754 -0.017038 11.6829 0.00995276 11.7836C0.0369436 11.8844 0.115623 11.9631 0.216354 11.99C0.317085 12.017 0.424564 11.9882 0.498304 11.9145L6 6.4128L11.5017 11.9145C11.6157 12.0285 11.8005 12.0285 11.9145 11.9145C12.0285 11.8005 12.0285 11.6157 11.9145 11.5017L6.4128 6Z",
    id: "Close",
    fill: "#007F00",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.70337abe837ac85c11e9904006501221.svg";
export { ForwardRef as ReactComponent };